<span [class]="'d-inline-block flex-grow-0 flex-shrink-0 align-middle lh-1 text-' + data?.notificationType"
      [ngSwitch]="data?.notificationType">
  <mat-icon class="mr-2" fontSet="fill" *ngSwitchCase="'success'">check_circle</mat-icon>
  <mat-icon class="mr-2" fontSet="fill" *ngSwitchCase="'warning'">warning</mat-icon>
  <mat-icon class="mr-2 text-danger" fontSet="fill" *ngSwitchCase="'error'">error</mat-icon>
  <mat-icon class="mr-2" fontSet="fill" *ngSwitchCase="'info'">info</mat-icon>
</span>
<div [class]="'flex-fill content text-' + (data?.notificationType === 'error' ? 'danger' : data?.notificationType)">
  <div class="text-break">
    <ng-template [cdkPortalOutlet]="contentPortal"></ng-template>
  </div>
  <p *ngIf="data && data.notificationType === 'normal'">
    <a href="javascript:void(0);" (click)="close()" i18n="@@common.dismiss">Dismiss</a>
  </p>
</div>
<button
        class="btn-close"
        type="button"
        mat-icon-button
        *ngIf="showClose"
        (click)="close()">
  <mat-icon fontSet="fill">close</mat-icon>
</button>